export const carouselItems = [
  {
    id: 1,
    tag: "重磅爆料",
    title: "某顶流艺人私生活大起底：圈内人实名爆料引热议",
    summary: "近日多位圈内人士接连发声，揭露某顶流艺人多年来不为人知的私生活细节，涉及多方利益纠葛，引发全网关注与讨论。",
    image: "https://readdy.ai/api/search-image?query=Celebrity%20gossip%20scandal%20breaking%20news%20concept%20with%20dramatic%20lighting%20and%20silhouette%20figures%2C%20warm%20red%20and%20dark%20tones%2C%20entertainment%20industry%20conspiracy%20theme%2C%20mysterious%20atmosphere%2C%20high%20contrast%2C%20editorial%20photography%20style%2C%20cinematic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape",
    hot: "98.7万热度",
    time: "2小时前",
  },
  {
    id: 2,
    tag: "深度调查",
    title: "某知名企业高管涉嫌利益输送，内部文件遭曝光",
    summary: "一份疑似内部财务文件在网络流传，直指某知名上市公司高管涉嫌通过关联交易进行利益输送，涉及金额或达数亿元。",
    image: "https://readdy.ai/api/search-image?query=Corporate%20scandal%20investigation%20concept%2C%20leaked%20documents%20on%20desk%20with%20dramatic%20shadow%20lighting%2C%20business%20secrets%20exposed%2C%20dark%20corporate%20office%20atmosphere%2C%20warm%20amber%20and%20dark%20tones%2C%20investigative%20journalism%20theme&width=800&height=500&seq=carousel-02&orientation=landscape",
    hot: "86.3万热度",
    time: "5小时前",
  },
  {
    id: 3,
    tag: "独家揭秘",
    title: "网红主播被曝虚假人设，幕后团队运作细节全公开",
    summary: "曾以真诚人设走红的某头部主播，被前团队成员公开幕后包装流程，从人设打造到剧本编排，完整产业链浮出水面。",
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20influencer%20scandal%20exposed%2C%20behind%20the%20scenes%20studio%20with%20dramatic%20reveal%20lighting%2C%20social%20media%20deception%20theme%2C%20warm%20dramatic%20tones%2C%20streaming%20equipment%20in%20mysterious%20atmosphere%2C%20cinematic%20composition&width=800&height=500&seq=carousel-03&orientation=landscape",
    hot: "75.2万热度",
    time: "8小时前",
  },
  {
    id: 4,
    tag: "实时追踪",
    title: "某综艺节目录制现场突发冲突，多方说法各执一词",
    summary: "热门综艺录制过程中发生意外冲突事件，节目组、嘉宾方、观众三方说法截然不同，真相仍待进一步核实。",
    image: "https://readdy.ai/api/search-image?query=TV%20show%20recording%20set%20conflict%20scene%20concept%2C%20dramatic%20stage%20lighting%20with%20tense%20atmosphere%2C%20entertainment%20industry%20drama%2C%20warm%20spotlight%20and%20dark%20shadows%2C%20theatrical%20composition%2C%20behind%20scenes%20chaos&width=800&height=500&seq=carousel-04&orientation=landscape",
    hot: "69.8万热度",
    time: "10小时前",
  },
  {
    id: 5,
    tag: "行业黑幕",
    title: "娱乐圈选角潜规则再起波澜，多位新人演员联合发声",
    summary: "数位刚入行的年轻演员在社交平台集体爆料，揭露部分剧组选角过程中存在的不正当交易和潜规则行为。",
    image: "https://readdy.ai/api/search-image?query=Audition%20room%20drama%20concept%2C%20young%20actors%20silhouette%20under%20dramatic%20spotlight%2C%20entertainment%20industry%20dark%20side%2C%20mysterious%20atmosphere%20with%20warm%20red%20accents%2C%20casting%20couch%20theme%2C%20cinematic%20photography&width=800&height=500&seq=carousel-05&orientation=landscape",
    hot: "62.4万热度",
    time: "12小时前",
  },
  {
    id: 6,
    tag: "热点解码",
    title: "年度最具争议娱乐事件回顾：那些我们吃过的瓜",
    summary: "从年初的惊天大瓜到年末的反转再反转，回顾这一年最让人记忆深刻的娱乐争议事件，每一个都曾引爆全网讨论。",
    image: "https://readdy.ai/api/search-image?query=Entertainment%20year%20review%20collage%20concept%2C%20dramatic%20newspaper%20headlines%20scattered%20artistically%2C%20warm%20lighting%20with%20dark%20accents%2C%20gossip%20news%20compilation%2C%20editorial%20photography%20style%2C%20cinematic%20mood&width=800&height=500&seq=carousel-06&orientation=landscape",
    hot: "58.1万热度",
    time: "1天前",
  },
];

export const updatesItems = [
  { id: 1, time: "14:32", tag: "快讯", content: "某知名导演新片拍摄现场路透曝光，主演造型引发粉丝热议" },
  { id: 2, time: "13:15", tag: "爆料", content: "圈内人士透露某偶像团体即将解散，成员各自发展去向成谜" },
  { id: 3, time: "11:48", tag: "独家", content: "某卫视跨年晚会阵容疑似泄露，多位顶流艺人确认加盟" },
  { id: 4, time: "10:20", tag: "追踪", content: "昨日被曝光的某企业高管事件持续发酵，相关方已启动内部调查" },
  { id: 5, time: "09:05", tag: "热议", content: "某热播剧编剧回应争议：剧本经过多轮修改，不存在抄袭行为" },
  { id: 6, time: "07:50", tag: "首发", content: "某品牌代言人更换内幕：新老代言人之间存在不为人知的竞争关系" },
  { id: 7, time: "昨天 22:30", tag: "快讯", content: "某音乐节演出突发状况，主办方紧急协调替补艺人" },
  { id: 8, time: "昨天 19:15", tag: "爆料", content: "某演员被目击与神秘异性深夜同行，疑似新恋情曝光" },
  { id: 9, time: "昨天 16:40", tag: "追踪", content: "此前曝光的综艺冲突事件，节目组正式发布声明回应舆论" },
];

export const faqItems = [
  {
    id: 1,
    question: "黑料吃瓜网的内容来源是否可靠？",
    answer: "黑料吃瓜网所有内容均来源于公开网络信息及用户投稿，我们会尽可能对信息进行多方交叉验证。但由于爆料内容的特殊性，部分信息可能存在争议，建议广大网友理性看待，以官方发布信息为准。我们也会在获得最新进展后及时更新相关内容。",
  },
  {
    id: 2,
    question: "如何在黑料吃瓜网在线观看最新爆料视频？",
    answer: "您可以直接访问黑料吃瓜网首页，在视频专区和各分区板块中浏览最新爆料视频。所有视频均支持在线播放，无需下载任何插件或软件，点击即可观看。我们每天更新大量高清爆料内容，涵盖一区二区等多个分区，使用手机或电脑均可流畅浏览。",
  },
  {
    id: 3,
    question: "黑料吃瓜网曝一区二区是什么意思？",
    answer: "一区二区是黑料吃瓜网的内容分区体系。一区主要汇集娱乐圈明星艺人相关的爆料内容，包括演员、歌手、偶像团体等；二区则涵盖网红主播、综艺节目、影视制作等泛娱乐领域的资讯和爆料。通过分区体系，用户可以快速定位自己感兴趣的吃瓜内容类型。",
  },
  {
    id: 4,
    question: "我可以向黑料吃瓜网投稿爆料内容吗？",
    answer: "当然可以！我们非常欢迎广大网友提供真实可靠的爆料信息。您可以通过网站的投稿联系入口提交内容，提交时请尽可能提供详细的线索和证据材料。我们会对所有投稿进行严格审核，确保内容质量后再进行发布。同时，我们承诺严格保护投稿人的隐私信息安全。",
  },
  {
    id: 5,
    question: "黑料吃瓜网站在线观看是否需要注册账号？",
    answer: "不需要。黑料吃瓜网目前完全免费开放，所有内容均可直接在线观看，无需注册账号或登录。我们致力于为网友提供最便捷的吃瓜体验，让您随时随地畅享最新爆料内容。后续如有会员专属服务上线，我们会提前公告通知。",
  },
  {
    id: 6,
    question: "遇到不实或侵权内容应该如何处理？",
    answer: "如果您发现黑料吃瓜网上的内容存在不实信息或侵犯了您的合法权益，请通过网站的投诉反馈渠道联系我们，并提供相关证明材料。我们会在收到投诉后的24小时内进行核实处理，对于确认存在问题的内容将及时下架或更正。我们坚决维护网络信息环境的清朗与公正。",
  },
];

export const featuresItems = [
  {
    id: 1,
    icon: "ri-flashlight-line",
    title: "全网最快爆料",
    description: "24小时全天候监控全网热点，第一时间呈现最新爆料内容，让您永远比朋友圈先知道。",
  },
  {
    id: 2,
    icon: "ri-stack-line",
    title: "分区清晰易找",
    description: "一区二区分门别类，娱乐圈、网红圈、综艺圈各自独立，想看什么一点即达。",
  },
  {
    id: 3,
    icon: "ri-shield-check-line",
    title: "多重信息核验",
    description: "编辑团队对每一条爆料进行多源交叉验证，力求呈现最接近真相的内容。",
  },
  {
    id: 4,
    icon: "ri-smartphone-line",
    title: "全终端高清体验",
    description: "无论手机还是电脑，所有视频均支持高清在线播放，流畅不卡顿，无需下载。",
  },
];

export const indexItems = [
  { id: 1, title: "娱乐圈一区", desc: "明星艺人最新爆料合集", count: "1,286条", icon: "ri-star-line" },
  { id: 2, title: "网红圈二区", desc: "主播达人八卦追踪", count: "953条", icon: "ri-live-line" },
  { id: 3, title: "综艺爆料", desc: "热门综艺幕后揭秘", count: "721条", icon: "ri-tv-line" },
  { id: 4, title: "影视动态", desc: "剧组拍摄一手消息", count: "634条", icon: "ri-film-line" },
  { id: 5, title: "音乐资讯", desc: "歌手乐坛最新动向", count: "518条", icon: "ri-music-line" },
  { id: 6, title: "时尚八卦", desc: "明星穿搭品牌代言", count: "472条", icon: "ri-shirt-line" },
  { id: 7, title: "体育娱乐", desc: "运动员跨界娱乐新闻", count: "395条", icon: "ri-basketball-line" },
  { id: 8, title: "社会热点", desc: "热门事件深度解读", count: "346条", icon: "ri-fire-line" },
  { id: 9, title: "海外吃瓜", desc: "国际娱乐圈资讯速递", count: "289条", icon: "ri-global-line" },
];

export const appItem = {
  title: "随时随地 · 畅快吃瓜",
  desc: "黑料吃瓜网移动端专属页面已上线，浏览器访问即用，无需下载。手机浏览适配完美，高清视频流畅播放，让你走到哪吃到哪。",
  features: ["免下载即用", "手机适配流畅", "高清视频播放", "实时推送更新"],
};

export const rankingItems = [
  { id: 1, rank: 1, title: "某顶流艺人私生活大起底", hot: "98.7万", trend: "up", tag: "HOT" },
  { id: 2, rank: 2, title: "知名企业高管利益输送内幕", hot: "86.3万", trend: "up", tag: "NEW" },
  { id: 3, rank: 3, title: "网红主播虚假人设全公开", hot: "75.2万", trend: "up", tag: "HOT" },
  { id: 4, rank: 4, title: "综艺录制现场突发冲突事件", hot: "69.8万", trend: "stable", tag: "" },
  { id: 5, rank: 5, title: "多位新人演员联合发声爆料", hot: "62.4万", trend: "up", tag: "" },
  { id: 6, rank: 6, title: "年度争议娱乐事件大盘点", hot: "58.1万", trend: "down", tag: "" },
];

export const commentsItems = [
  {
    id: 1,
    avatar: "匿",
    name: "吃瓜群众A",
    time: "30分钟前",
    content: "这个瓜也太大了，我追了好几天的爆料终于有新进展了！黑料吃瓜网的速度确实可以，比别家快了好几个小时。坐等后续更多猛料。",
    likes: 2381,
  },
  {
    id: 2,
    avatar: "爆",
    name: "圈内知情人",
    time: "1小时前",
    content: "作为半个圈内人，我只能说这里面的水比大家想象的还要深。有些爆料虽然看着离谱，但真实情况可能更离谱。希望更多人站出来说实话。",
    likes: 1856,
  },
  {
    id: 3,
    avatar: "瓜",
    name: "理性吃瓜人",
    time: "2小时前",
    content: "建议大家理性看待这些爆料信息，不要盲目相信也不要全盘否定。多方求证、独立思考很重要。黑料吃瓜网的整理确实帮了大忙，信息很全面。",
    likes: 1432,
  },
  {
    id: 4,
    avatar: "料",
    name: "深夜追瓜侠",
    time: "3小时前",
    content: "每天晚上睡前都要来黑料吃瓜网逛一圈，不然第二天跟同事都没话题聊了哈哈。最近更新的速度越来越快，质量也越来越高，爱了爱了。",
    likes: 1207,
  },
];

export const contactItem = {
  title: "有料你就来",
  desc: "如果您掌握娱乐圈、网红圈或社会热点的一手爆料信息，欢迎通过以下方式联系我们。我们承诺严格保护投稿人隐私，重要线索一经采用将给予丰厚奖励。",
  methods: [
    { icon: "ri-mail-line", label: "投稿邮箱", value: "tougao@heiliao.com" },
    { icon: "ri-wechat-line", label: "微信客服", value: "heiliao-kefu" },
    { icon: "ri-message-2-line", label: "站内私信", value: "点击发送私信" },
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: "独家专访：圈内大佬揭秘娱乐圈选角内幕",
    duration: "15:28",
    views: "125.6万",
    image: "https://readdy.ai/api/search-image?query=Exclusive%20interview%20studio%20setup%20with%20dramatic%20lighting%2C%20entertainment%20industry%20insider%20revealing%20secrets%2C%20warm%20atmosphere%20with%20dark%20background%2C%20professional%20video%20production%20style%2C%20cinematic%20interview%20lighting&width=640&height=360&seq=media-01&orientation=landscape",
    tag: "独家",
  },
  {
    id: 2,
    title: "深度解析：某顶流翻车事件完整时间线梳理",
    duration: "22:15",
    views: "98.3万",
    image: "https://readdy.ai/api/search-image?query=Timeline%20investigation%20video%20thumbnail%20concept%2C%20dramatic%20documentary%20style%20with%20warm%20tones%2C%20entertainment%20news%20analysis%2C%20dark%20cinematic%20lighting%20with%20red%20accents%2C%20investigative%20journalism%20visual%20style&width=640&height=360&seq=media-02&orientation=landscape",
    tag: "深度",
  },
  {
    id: 3,
    title: "实拍直击：某综艺录制现场意外冲突全过程",
    duration: "08:42",
    views: "156.2万",
    image: "https://readdy.ai/api/search-image?query=Dramatic%20behind%20the%20scenes%20TV%20show%20footage%20concept%2C%20stage%20conflict%20atmosphere%20with%20warm%20spotlight%20and%20dark%20shadows%2C%20entertainment%20production%20chaos%2C%20cinematic%20documentary%20style%2C%20handheld%20camera%20aesthetic&width=640&height=360&seq=media-03&orientation=landscape",
    tag: "实拍",
  },
];

export const aboutItem = {
  title: "关于黑料吃瓜网",
  sections: [
    {
      subtitle: "我们是谁",
      content: "黑料吃瓜网是国内领先的娱乐爆料资讯聚合平台，致力于为网友提供最新、最全、最真实的娱乐圈爆料内容。从明星八卦到行业黑幕，从网红动态到综艺幕后，我们用专业的态度做最认真的吃瓜内容。",
    },
    {
      subtitle: "我们的理念",
      content: "我们相信每个人都有了解真相的权利。黑料吃瓜网坚持独立、客观的内容原则，不接受任何利益方的删稿或修改要求。每一条爆料都经过编辑团队的多重核验，力求还原事实全貌。",
    },
    {
      subtitle: "内容覆盖",
      content: "目前黑料吃瓜网已覆盖娱乐圈、网红圈、综艺圈、音乐圈、时尚圈、体育娱乐等多个领域的内容板块，形成了一区二区的完整分区体系。每天更新数百条最新爆料，满足不同用户的吃瓜需求。",
    },
  ],
  stats: [
    { value: "15,000+", label: "累计爆料" },
    { value: "8,000万+", label: "月均浏览" },
    { value: "500万+", label: "活跃用户" },
  ],
};

export const topicsItems = [
  { id: 1, name: "顶流翻车", count: "1,286条", hot: true },
  { id: 2, name: "综艺内幕", count: "893条", hot: true },
  { id: 3, name: "网红人设崩塌", count: "756条", hot: true },
  { id: 4, name: "艺人恋情曝光", count: "672条", hot: false },
  { id: 5, name: "影视剧争议", count: "591条", hot: false },
  { id: 6, name: "品牌代言风波", count: "534条", hot: false },
  { id: 7, name: "选秀黑幕", count: "478条", hot: true },
  { id: 8, name: "音乐圈是非", count: "412条", hot: false },
  { id: 9, name: "直播带货纠纷", count: "367条", hot: false },
  { id: 10, name: "跨界艺人八卦", count: "298条", hot: false },
];

export const cardsItems = [
  {
    id: 1,
    tag: "娱乐圈一区",
    title: "某知名歌手被曝与经纪公司解约内幕，天价违约金成焦点",
    summary: "合约条款细节曝光，涉及金额或创行业纪录。多方消息源证实双方已进入法律程序，后续发展值得关注。",
    image: "https://readdy.ai/api/search-image?query=Music%20industry%20contract%20dispute%20concept%2C%20dramatic%20lawyer%20office%20scene%20with%20warm%20lighting%2C%20entertainment%20legal%20drama%2C%20documents%20on%20desk%2C%20dark%20academia%20vibe%2C%20cinematic%20composition&width=600&height=400&seq=card-01&orientation=landscape",
    time: "3小时前",
    views: "45.2万",
  },
  {
    id: 2,
    tag: "网红圈二区",
    title: "某头部带货主播被指数据造假，直播间真实人数遭质疑",
    summary: "第三方数据监测机构发布报告，指出多名主播存在直播间人气注水嫌疑。涉及的头部主播尚未正面回应。",
    image: "https://readdy.ai/api/search-image?query=Live%20streaming%20data%20manipulation%20concept%2C%20digital%20analytics%20dashboard%20with%20dramatic%20red%20accents%2C%20social%20media%20fraud%20theme%2C%20dark%20tech%20atmosphere%2C%20warm%20screen%20glow%2C%20cinematic%20mood&width=600&height=400&seq=card-02&orientation=landscape",
    time: "5小时前",
    views: "38.7万",
  },
  {
    id: 3,
    tag: "综艺爆料",
    title: "某选秀节目被匿名举报操纵投票，相关监管部门介入调查",
    summary: "一封匿名举报信在网络流传，详细列举了节目组涉嫌操控观众投票的具体手段。监管部门表示已收到举报材料。",
    image: "https://readdy.ai/api/search-image?query=Talent%20show%20voting%20scandal%20concept%2C%20dramatic%20stage%20with%20spotlight%20and%20voting%20screens%2C%20entertainment%20controversy%2C%20warm%20dramatic%20lighting%2C%20television%20production%20set%2C%20cinematic%20photography&width=600&height=400&seq=card-03&orientation=landscape",
    time: "7小时前",
    views: "52.1万",
  },
  {
    id: 4,
    tag: "影视动态",
    title: "某大制作电影拍摄现场流出剧照，主角造型成为热议焦点",
    summary: "一组疑似片场偷拍照在社交平台疯传，主演的全新造型引发粉丝两极分化讨论。片方暂未对此事做出回应。",
    image: "https://readdy.ai/api/search-image?query=Film%20set%20leaked%20photo%20concept%2C%20dramatic%20movie%20production%20scene%20with%20warm%20lighting%2C%20behind%20the%20scenes%20cinema%2C%20mysterious%20atmosphere%2C%20costume%20reveal%20in%20dramatic%20setting%2C%20cinematic%20composition&width=600&height=400&seq=card-04&orientation=landscape",
    time: "9小时前",
    views: "41.6万",
  },
  {
    id: 5,
    tag: "音乐资讯",
    title: "某天后级歌手新专辑疑似被恶意泄露，工作室紧急启动维权",
    summary: "完整专辑曲目和试听片段在多个平台出现，疑似内部人员泄露。工作室声明将追究法律责任。",
    image: "https://readdy.ai/api/search-image?query=Music%20album%20leak%20controversy%20concept%2C%20dramatic%20recording%20studio%20with%20warm%20low%20lighting%2C%20music%20industry%20secrets%20exposed%2C%20dark%20creative%20space%2C%20professional%20audio%20equipment%2C%20cinematic%20mood&width=600&height=400&seq=card-05&orientation=landscape",
    time: "11小时前",
    views: "67.3万",
  },
  {
    id: 6,
    tag: "时尚八卦",
    title: "某奢侈品牌代言人更换内幕：新旧代言人暗战升级",
    summary: "品牌方内部人士透露，本次代言人更换并非合约到期那么简单，背后涉及多方资源博弈和私人恩怨。",
    image: "https://readdy.ai/api/search-image?query=Luxury%20brand%20endorsement%20drama%20concept%2C%20fashion%20runway%20with%20dramatic%20lighting%2C%20celebrity%20endorsement%20conflict%2C%20warm%20gold%20and%20dark%20tones%2C%20high%20fashion%20atmosphere%2C%20cinematic%20editorial%20style&width=600&height=400&seq=card-06&orientation=landscape",
    time: "14小时前",
    views: "33.5万",
  },
  {
    id: 7,
    tag: "海外吃瓜",
    title: "好莱坞某影帝被曝税务问题缠身，多家媒体跟进报道",
    summary: "知名调查媒体放出重磅报道，指某奥斯卡影帝通过离岸公司逃避巨额税款，事件正在持续发酵中。",
    image: "https://readdy.ai/api/search-image?query=Hollywood%20tax%20scandal%20concept%2C%20dramatic%20courtroom%20or%20legal%20documents%20scene%2C%20celebrity%20legal%20trouble%20theme%2C%20warm%20dramatic%20lighting%2C%20dark%20luxury%20atmosphere%2C%20cinematic%20investigative%20journalism%20style&width=600&height=400&seq=card-07&orientation=landscape",
    time: "1天前",
    views: "29.8万",
  },
];